import ENV from "@config/env";
import { useAppContext } from "@context/AppContext";
import { useAllSubscriberExtractionPoints } from "@hooks/query/zenith/useAllExtractionPoints";
import { useGetSubscriber } from "@hooks/query/zenith/useGetSubscriber";
import { getLatitudeLongitude } from "@utils/getLatitudeLongitude";
import {
  subscriberLocations,
  type WeatherLocation,
} from "./subscriberLocations";

const { lat, lng } = getLatitudeLongitude(ENV.DEFAULT_WEATHER_LOCATION);
/** The tenant's stand-in for a subscriber with no located offtake or address, from the frontend env. */
export const DEFAULT_LOCATION: WeatherLocation = {
  id: "default",
  name: ENV.DEFAULT_WEATHER_LOCATION_NAME,
  place: { lat: lat!, lng: lng! },
};

/**
 * The logged-in subscriber's weather locations, subscriber location first; undefined while they load. Only the
 * dashboard's weather and dam cards need them, so a failure is theirs to show, not the dashboard's.
 */
export const useSubscriberLocations = () => {
  const { loggedInInfo } = useAppContext();
  const { subscriberId, walletId } = loggedInInfo?.userDetails ?? {};

  const { data: subscriber, isError: isSubscriberError } = useGetSubscriber({
    id: subscriberId,
    options: { enabled: Boolean(subscriberId), useErrorBoundary: false },
  });
  // Scoped to the selected scheme by the API.
  const { data: offtakes, isError: isOfftakesError } =
    useAllSubscriberExtractionPoints({
      params: { definedByWalletId: walletId },
      options: { enabled: Boolean(walletId), useErrorBoundary: false },
    });

  return {
    locations:
      subscriber && offtakes
        ? subscriberLocations(subscriber, offtakes, DEFAULT_LOCATION)
        : undefined,
    isError: isSubscriberError || isOfftakesError,
  };
};
